<template>
  <main id="main-content" class="not-found landing--light" tabindex="-1">
    <section class="not-found__section">
      <div class="not-found__card">
        <p class="not-found__code">404</p>
        <h1 class="not-found__title">Страница не найдена</h1>
        <p class="not-found__lead">
          Такой страницы нет или она была перемещена. Вернитесь на главную и продолжите работу.
        </p>
        <div class="not-found__actions">
          <router-link to="/" class="not-found__btn not-found__btn--primary">На главную</router-link>
          <button type="button" class="not-found__btn not-found__btn--ghost" @click="goBack">Назад</button>
        </div>
        <p class="not-found__hint">
          Если ошибка повторяется, напишите на
          <a href="mailto:Ai@neyrosvet.ru">Ai@neyrosvet.ru</a>.
        </p>
      </div>
    </section>
    <footer class="not-found__footer">
      <span>© {{ year }} AI-Tenders</span>
      <router-link to="/offer">Оферта</router-link>
      <router-link to="/privacy">Политика персональных данных</router-link>
      <span>{{ operatorRequisitesLine }}</span>
    </footer>
  </main>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { operatorRequisitesLine } from '@/content/legal/operator'

const router = useRouter()
const year = new Date().getFullYear()

function goBack() {
  if (window.history.length > 1) {
    router.back()
    return
  }
  router.push('/')
}
</script>

<style scoped>
.landing--light {
  --fg: #0f172a;
  --muted: #516078;
  --blue: #1e3a8a;
  --blue-accent: #1d4ed8;
  --surface: #ffffff;
  --border: #d2dbe8;
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fc 0%, #eff4fb 100%);
  color: var(--fg);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
}

.not-found {
  display: flex;
  flex-direction: column;
}

.not-found__section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.not-found__card {
  width: min(100%, 700px);
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.09);
  padding: clamp(1.5rem, 4vw, 2.5rem);
  text-align: center;
}

.not-found__code {
  margin: 0;
  font-size: clamp(2.2rem, 7vw, 3.6rem);
  font-weight: 800;
  letter-spacing: 0.08em;
  color: var(--blue);
}

.not-found__title {
  margin: 0.5rem 0 0.9rem;
  font-size: clamp(1.4rem, 3vw, 2rem);
  font-weight: 700;
}

.not-found__lead {
  margin: 0 auto;
  max-width: 42ch;
  color: var(--muted);
  line-height: 1.6;
}

.not-found__actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.not-found__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 10.5rem;
  padding: 0.7rem 1.2rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  border: 1px solid transparent;
  cursor: pointer;
  transition: 0.2s ease;
}

.not-found__btn--primary {
  background: linear-gradient(135deg, var(--blue) 0%, var(--blue-accent) 100%);
  color: #fff;
}

.not-found__btn--ghost {
  background: #fff;
  border-color: var(--border);
  color: var(--fg);
}

.not-found__btn:hover {
  transform: translateY(-1px);
}

.not-found__hint {
  margin: 1.25rem 0 0;
  color: var(--muted);
  font-size: 0.92rem;
}

.not-found__hint a {
  color: var(--blue-accent);
}

.not-found__footer {
  border-top: 1px solid var(--border);
  padding: 1rem;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.7rem 1.2rem;
  color: var(--muted);
  font-size: 0.88rem;
}

.not-found__footer a {
  color: var(--blue-accent);
  text-decoration: none;
}

.not-found :is(a, button):focus-visible {
  outline: 2px solid var(--blue-accent);
  outline-offset: 2px;
}
</style>
